import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import { LotusPetals } from "./LotusPetals";
import { InquiryForm } from "@/components/InquiryForm";
import { useEffect, useState } from 'react';
import { getSettings } from '@/lib/api';
import heroImage from "@/assets/hero-bg.jpg";
import heroImageWebp from "@/assets/hero-bg.webp";
import heroVideoMp4 from "@/assets/home-bg.mp4";
import heroVideoMobileMp4 from "@/assets/home-bg-mobile.mp4";

export const Hero = () => {
  const scrollToContent = () => {
    const element = document.getElementById("introduction");
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Asset */}
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster="/hero-poster.jpg"
        >
          <source src={heroVideoMobileMp4} type="video/mp4" media="(max-width: 768px)" />
          <source src={heroVideoMp4} type="video/mp4" />
          <img loading="lazy" 
            src={heroImageWebp} 
            alt="Hero Background" 
            // @ts-ignore
            fetchPriority="high"
            decoding="async"
            className="w-full h-full object-cover"
          />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-indigo/70 via-indigo/50 to-indigo/80" />
      </div>

      {/* Floating Lotus Petals */}
      <LotusPetals />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Decorative Element */}
          <div className="flex items-center justify-center gap-4 mb-8 animate-fade-in-up opacity-0" style={{ animationDelay: "0.2s" }}>
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-gold/50" />
            <span className="text-gold text-sm tracking-[0.3em] uppercase">Reactivating the Spiritual Circuits</span>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-gold/50" />
          </div>

          {/* Main Heading */}
          <h1 className="font-serif text-4xl md:text-5xl lg:text-7xl text-primary-foreground leading-tight mb-6 animate-fade-in-up opacity-0" style={{ animationDelay: "0.4s" }}>
            Transformative Spiritual Journeys
            {/* <br />
            <span className="text-gradient-sacred">Journey Within Yourself.</span> */}
          </h1>

          {/* Subtext */}
          <p className="text-lg md:text-xl text-primary-foreground/80 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-up opacity-0" style={{ animationDelay: "0.6s" }}>
            We invite you to immerse yourself in India’s centuries-old traditions, exploring ashrams, monasteries, daily rituals, and the teachings of monastic teachers. Our spiritual circuits are designed to help you reconnect with yourself, find healing, and uncover a sense of purpose.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up opacity-0" style={{ animationDelay: "0.8s" }}>
            <Link to="/circuits">
              <Button variant="sacred" size="xl">
                Explore Our Circuits
              </Button>
            </Link>
            {/* <InquiryForm 
              trigger={
                <Button variant="hero" size="xl">
                  Request a Tour
                </Button>
              }
            /> */}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <button
          onClick={scrollToContent}
          className="text-primary-foreground/60 hover:text-primary-foreground transition-colors animate-float-slow cursor-pointer"
          aria-label="Scroll to content"
        >
          <ChevronDown className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
};